import { useEffect } from 'react';

const PWA_HEAD_MARKER = 'data-sol-buyer-pwa';

function removePwaHeadTags() {
  document
    .querySelectorAll(`[${PWA_HEAD_MARKER}]`)
    .forEach((element) => element.remove());
}

function appendMeta(name: string, content: string) {
  const meta = document.createElement('meta');
  meta.setAttribute(PWA_HEAD_MARKER, 'true');
  meta.name = name;
  meta.content = content;
  document.head.appendChild(meta);
}

function appendLink(rel: string, href: string) {
  const link = document.createElement('link');
  link.setAttribute(PWA_HEAD_MARKER, 'true');
  link.rel = rel;
  link.href = href;
  document.head.appendChild(link);
}

function hasStaticManifestLink() {
  return Boolean(
    document.querySelector('link[rel="manifest"]:not([data-sol-buyer-pwa])')
  );
}

export function usePwaHeadMetadata(isEnabled: boolean, isLoading: boolean) {
  useEffect(() => {
    if (isLoading) return;

    removePwaHeadTags();
    if (!isEnabled) return;
    if (hasStaticManifestLink()) return;

    appendLink('manifest', '/manifest.json');
    appendLink('apple-touch-icon', '/images/favicon/apple-touch-icon.png');
    appendMeta('apple-mobile-web-app-capable', 'yes');
    appendMeta('apple-mobile-web-app-status-bar-style', 'default');
    appendMeta('apple-mobile-web-app-title', 'Sukanda OneLink');

    return removePwaHeadTags;
  }, [isEnabled, isLoading]);
}
